import React from "react";
import TkBasicHeader from "./components/clissfiyHeader/BasicHeader";
import TkHoujinHeader from "./components/clissfiyHeader/HoujinHeader";
import TkKikoHeader from "./components/clissfiyHeader/KikoHeader";
import TkTaisyokusyaHeader from "./components/clissfiyHeader/TaisyokusyaHeader";
import { TkHeaderProps } from "../../../type/componentsType/TkHeaderType";
import authorityUserType from "../../../assets/data/TkAuthorityProperty";
import TkDaikouHeader from "./components/clissfiyHeader/DaikouHeader";

export const HeaderContext = React.createContext("");

/**
 * ヘッダー部品（メイン）
 * ヘッダー部品のメインレイアウト
 * @param {TkHeaderProps} props - TkHeaderコンポーネントのprops
 * @param {string} props.title - ヘッダータイトル
 * @param {string} props.userType - ユーザータイプ
 * @param {number} props.sideBarWidth - サイドバーの幅
 * @param {boolean} props.hideButton - ボタンを非表示にするかどうか
 * @param {string} props.headerName - ヘッダー名
 * @param {string} props.department - 部署名
 * @return {React.FC<TkHeaderProps>} TkHeader ヘッダー部品（メイン）
 */
export const TkHeader: React.FC<TkHeaderProps> = (props) => {
  const {
    title = "",
    userType,
    sideBarWidth,
    hideButton,
    headerName = "",
    department = "",
  } = props;
  let ResComponent: React.FC<any> = TkHoujinHeader;

  const headerComponents: { [key: number]: React.FC<any> } = {
    [authorityUserType.userTypeNumber.KEIYAKUSYA]: TkHoujinHeader,
    [authorityUserType.userTypeNumber.KIKO]: TkKikoHeader,
    [authorityUserType.userTypeNumber.TAISYOKUSYA]: TkTaisyokusyaHeader,
    [authorityUserType.userTypeNumber.DAIKOSHA]: TkDaikouHeader,
  };

  ResComponent = headerComponents[userType] || TkBasicHeader;

  return (
    <HeaderContext.Provider value={title}>
      <ResComponent
        sideBarWidth={sideBarWidth}
        headerName={headerName}
        department={department}
        hideButton={hideButton}
        userType={userType}
      ></ResComponent>
    </HeaderContext.Provider>
  );
};

export default TkHeader;
